<template>
  <div id="div">
    <el-form v-loading="loading" id="form" :model="form" status-icon :rules="rules2" ref="form" label-width="120px" class="demo-ruleForm">
      <h1>Login</h1>
      <el-form-item label="Username" prop="username">
        <el-input type="text" v-model="form.username" ref="username"></el-input>
      </el-form-item>
      <el-form-item label="Password" prop="passw">
        <el-input type="password" v-model="form.passw" ref="password"></el-input>
      </el-form-item>
      <el-button class="--secondary" id="submitButton" type="primary" @click="submitForm('form')">Submit</el-button>
    </el-form>
  </div>
</template>

<script>
  import ElCol from "element-ui/packages/col/src/col";
  import axios from 'axios';

  export default {
    components: {ElCol},
    data() {
      let validateUsername = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Please input the username!'));
        }else {
          callback();
        }
      };
      let validatePassw = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Please input the password!'));
        }else {
          callback();
        }
      };

      return {
        loading: false,
        form: {
          username: '',
          passw: '',
        },
        rules2: {
          username: [
            { validator: validateUsername, trigger: 'blur' }
          ],
          passw: [
            { validator: validatePassw, trigger: 'blur' }
          ]
        }
      };
    },
    methods: {
      submitForm(formName) {
        let app = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            axios.post(`https://iiot.dave.eu/api/verifyUser`, {
              username: `${this.$refs.username.value}`,
              password: `${this.$refs.password.value}`,
            }).then(function (response) {
                app.loading = true;
                app.$cookie.set('user', app.$refs.username.value, { expires: '1D' });
                if(response.data.image !== null)
                  document.getElementById("avatar").src = response.data.image;
                app.$notify({
                    title: 'Ok!',
                    message: `Log-in successful`,
                    type: 'success',
                    duration: 1000,
                  });

                setTimeout(function () {
                  app.$router.push('/index')
                  app.Themer(response);
                },1000)
              }).catch(function (error) {
                app.$notify({
                  title: 'ERROR',
                  message: `Can't verify the user: ${error.response.data.message}`,
                  type: 'error'
                });
            })

          } else {
            console.error('ERROR during the submit!');
            return false;
          }
        });
      },
      Themer(response){
        let colors = response.data.colors.split(",");
        let metaThemeColor = document.querySelector("meta[name=theme-color]");

        // Select the style document and change the properties
        let bodyStyles = document.body.style;
        bodyStyles.setProperty('--primary-color', colors[0]);
        bodyStyles.setProperty('--secondary-color', colors[1]);
        bodyStyles.setProperty('--tertiary-color', colors[2]);

        // Set the meta theme color to reflect the change (for mobile)
        metaThemeColor.setAttribute("content", colors[0]);
      },
    },
    mounted: function () {
      if(this.$cookie.get('user')) {
        this.$router.push('/index')
      }
    }
  }
</script>


<style  scoped>
  #form{
    min-width: 266px;
    max-width: 300px;
    padding: 2%;
  }

  #submitButton{
    margin-top: 3%;
  }

  #div{
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue